import { render, staticRenderFns } from "./FormActions.vue?vue&type=template&id=160ea8c8&scoped=true&"
import script from "./FormActions.vue?vue&type=script&lang=ts&"
export * from "./FormActions.vue?vue&type=script&lang=ts&"
import style0 from "./FormActions.vue?vue&type=style&index=0&id=160ea8c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160ea8c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
